/**
 * Constants for NPS drawer component
 * Centralizes all magic numbers, colors, and repeated values
 *
 * Brand-divergent values (cooldown, deferral, eligibility delays) live in
 * the consuming app — this package is brand-blind.
 */

// Animation durations (in seconds)
export const ANIMATION = {
  MIN_DURATION: 0.15,
  MAX_DURATION: 0.27,
  HEIGHT_TRANSITION_DURATION: 0.27,
  AUTO_DISMISS_DELAY_MS: 2000, // milliseconds
  HEIGHT_DIFFERENCE_DIVISOR: 500, // Used for calculating dynamic opacity duration
} as const;

// Spacing values (in pixels)
export const SPACING = {
  DRAWER_BOTTOM: 40,
  DRAWER_SIDE_MARGIN: 16,
  CONTENT_PADDING: 24,
  CONTENT_GAP: 24,
  BUTTON_GAP: 16,
  LABEL_TOP_MARGIN: -16,
} as const;

// Z-index values
export const Z_INDEX = {
  DRAWER_CONTENT: 100000,
} as const;

// NPS score range
export const NPS_SCORES = {
  MIN: 0,
  MAX: 10,
  TOTAL_COUNT: 11,
} as const;

// Stage identifiers
export const NPS_STAGES = {
  SCORE_SELECTION: "score-selection",
  FOLLOW_UP: "follow-up",
  THANK_YOU: "thank-you",
} as const;
